import {
  _DisposeViewRepeaterStrategy,
  _RecycleViewRepeaterStrategy,
  _VIEW_REPEATER_STRATEGY,
} from '@angular/cdk/collections';
import {
  _COALESCED_STYLE_SCHEDULER,
  _CoalescedStyleScheduler,
  CDK_TABLE,
  CDK_TABLE_TEMPLATE,
  CdkTable,
  STICKY_POSITIONING_LISTENER,
} from '@angular/cdk/table';
import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';

/**
 * Enables the recycle view repeater strategy, which reduces rendering latency. Not compatible with
 * tables that animate rows.
 */
@Directive({
  selector: 'n-table[recycleRows], table[n-table][recycleRows]',
  providers: [{ provide: _VIEW_REPEATER_STRATEGY, useClass: _RecycleViewRepeaterStrategy }],
})
export class NRecycleRowsDirective {}

@Component({
  selector: 'n-table, table[n-table]',
  exportAs: 'nTable',
  template: CDK_TABLE_TEMPLATE,
  encapsulation: ViewEncapsulation.None,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
    { provide: CdkTable, useExisting: NTableComponent },
    { provide: CDK_TABLE, useExisting: NTableComponent },
    { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
    // Prevent nested tables from seeing this table's StickyPositioningListener.
    { provide: STICKY_POSITIONING_LISTENER, useValue: null },
  ],
})
export class NTableComponent<T> extends CdkTable<T> implements OnChanges {
  @Input() displayedColumns: string[] = [];
  @HostBinding('attr.class') class = 'table table-borderless table-striped';

  /** Overrides the sticky CSS class set by the `CdkTable`. */
  protected override stickyCssClass = 'table-sticky';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      const { multiTemplateDataRows } = changes;
      if (multiTemplateDataRows) {
        this.class = 'table table-borderless table-striped-pairs';
      }
    }
  }
}
